import axios from 'axios';
import { getToken } from 'utils/auth';

const BASE = process.env.REACT_APP_SURVEY_API_URL + '/api';

const authHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
  'Content-Type': 'application/json',
});

export const getAdminUsers = (filters = {}) =>
  axios
    .get(`${BASE}/users`, { headers: authHeaders(), params: filters })
    .then((r) => r.data);

export const createAdminUser = (data) =>
  axios
    .post(`${BASE}/users`, data, { headers: authHeaders() })
    .then((r) => r.data);

export const updateAdminUser = (username, data) =>
  axios
    .put(`${BASE}/users/${username}`, data, { headers: authHeaders() })
    .then((r) => r.data);

export const deleteAdminUser = (username) =>
  axios
    .delete(`${BASE}/users/${username}`, { headers: authHeaders() })
    .then((r) => r.data);

export const assignUserToSite = (username, siteId) =>
  axios
    .post(`${BASE}/users/${username}/assign-site`, { site_id: siteId }, { headers: authHeaders() })
    .then((r) => r.data);

export const setUserStatus = (username, status) =>
  axios
    .put(`${BASE}/users/${username}/status`, { status }, { headers: authHeaders() })
    .then((r) => r.data);
